import { PERSIST_SCHEMA_VERSION } from "@funded-here-interface/common/src/constant/persistConfig";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer, type PersistedState } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import { investorReducers } from "./reducers";

const persistConfig = {
  key: "root",
  version: PERSIST_SCHEMA_VERSION,
  storage: storageSession,
  whitelist: ["auth", "biz", "prof"], // Add other reducers you want to persist here
  migrate: async (state: PersistedState, currentVersion: number): Promise<PersistedState> => {
    if (!state) return undefined;
    if (state._persist.version === currentVersion) return state;
    // Preserve auth so user stays logged in; drop biz and prof to avoid stale shapes.
    const { auth } = state as PersistedState & { auth?: unknown };
    return { auth, _persist: state._persist } as PersistedState;
  },
};

const persistedReducer = persistReducer(persistConfig, combineReducers(investorReducers));

const store = configureStore({
  reducer: persistedReducer,
});
const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
